/*eslint-disable*/
const state = {
  vipPayInfo: {},
  showPlatMaintain: false,
  maintainContent: "",
  showRepwd: false, //显示强制更改密码
  linkList: {
    apkUrl: "",
    appJump: "",
    appDownload: "",
    customerUrl: "",
    ipaUrl: "",
    payDomain: "",
    staticDomain: "",
    regPhoneType: "1",
    agentDomain: "",
    downloadUrl:"",
    alipayWithdraw: "",
    cbPayWithdraw: "",
    kdPayWithdraw: "",
    limitUp: "",
    //新增钱包添加
    jdPayWithdraw: "",
    goPayWithdraw: "",
    usdtWithdraw: "",
    okPayWithdraw: "",
    vipPayWithdraw: "",
    ybfPayWithdraw: "",
    limitDown: "",
    loginCaptchaId: "", //登录易盾
    regCaptchaId: "", //注册易盾
    cs_Email: "", //邮箱
    cs_mobile: "", //手机号
    cs_qq: "", //客服QQ
    cs_wechat: "", //微信
    cs_agent_qq: "", //代理QQ
    easy_remember_url: "" //域名
  },
  FrontConfigList: {
    discount_service_QQ: "",
    customer_service_QQ: "",
    agent_service_link: ""
  },
  // 游戏列表
  allGameList: {
    slotList: [],
    liveList: [],
    sportsList: [],
    lotteryList: [],
    fishList: [],
    chessList: []
  },
  // 站内信条数
  inEmailNoRead: 0,
  // 维护的游戏平台列表
  maintain_game_platform_list: [],
  // 当前维护平台的信息提示
  maintain_game_info: "",
  // 当前维护平台的信息提示状态
  maintain_game_state: false,
  // 显示未登录状态弹框
  showLoginBox: false,
  showLoginBoxName: "loginFloat", //登录框显示组件
  // 显示忘记密码
  showPassword: false,
  //注册登录状态
  showloginfloat: false,
  showloginfloat2: false,

  // 是否支持支付宝提款 0=不支持 1=支持
  withdrawAp: 0,
  // 是否支持USDT提款 0=不支持 1=支持
  withdrawUSDT: 0,
  // 銀行卡數量限制 -1為不限制
  bankCardLimit: -1,
  navIndex: "/home",
  mineNavIndex: "/mine/center",
  slotsNavIndex: "/slots/allSlot",
  mineCapitalNavIndex: "/mine/capital/account",
  helpCenterNavIndex: "0",
  isLogin: false,
  UUID: "",
  picLink: "", // 老虎机图片地址
  frontType: 0, // 平台类型PC
  startMoney: 668229213.16, // 奖池起始金额
  // 各游戏平台列表
  slotList: [],
  liveCList: [],
  sportsList: [],
  lotteryList: [],
  catchFishList: [],
  chessList: [],
  // 1.一级导航type : 1.真人 2.体育 3.老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  indexNav: 0,
  liveNav: 1,
  slotsNav: 3,
  sportsNav: 2,
  esportsNav: 100,
  chessNav: 4,
  lotteryNav: 6,
  fishNav: 5,
  mineNav: 7,
  discountNav: 8,
  discountHall: 9,
  firstNav: {},
  // 优惠类型（锁定用）
  discountsTypes: [
    { key: "", value: "全部类型" },
    { key: "1", value: "返水红利" },
    { key: "2", value: "存款优惠" },
    // {key: '3',value: '邀请奖励'},
    // {key: '4',value: '签到奖励'},
    // {key: '6',value: '连续存款优惠'},
    { key: "A", value: "救援金" },
    { key: "B", value: "VIP升级奖励" },
    { key: "C", value: "VIP蝉联奖励" },
    { key: "5", value: "其他优惠" },
    { key: "7", value: "注册优惠" }
  ],

  // 威尼斯游戏
  // 首页广告
  isShowIndexAD: true,
  //集成弹框
  isShowPendantIndexAD: true,
  // 首页广告关闭数
  indexADCloseNum: 0,
  gameTypes: [
    { name: "所有游戏", code: -1 },
    { name: "老虎机", code: 1 },
    { name: "真人", code: 2 },
    { name: "体育", code: 3 },
    { name: "彩票", code: 4 },
    { name: "捕鱼王", code: 5 },
    { name: "棋牌", code: 6 },
    { name: "其他", code: 8 }
    // {name: '3D厅',code: 7},
  ],
  gameTypesJ2: [
    { name: "所有游戏", code: -1 },
    { name: "电子", code: 1 },
    { name: "棋牌", code: 6 },
    { name: "捕鱼", code: 5 },
    { name: "真人", code: 2 },
    { name: "体育", code: 3 },
    { name: "电竞", code: 10 },
    { name: "彩票", code: 4 },
    // { name: "其他", code: 8 },
    // {name: '3D厅',code: 7},
  ],
  BonusTypes: [{ articleId: 0 }],
  allBonusArticle: [], //所有优惠
  isNameVerify: true,
  isPhoneVerify: true,
  isMailVerify: true,
  // 老虎机收藏
  mySlot: [],
  // 底部文章导航列表
  downNav: [],

  // 用户信息
  userInfo: JSON.parse(localStorage.getItem("userInfo")) || {
    userInfo: {
      userAccount: "",
      withdrawPasswordValid: "",
      nameValid: "",
      mobileValid: "",
      emailValid: "",
      status: "",
      level: 1,
      mobilePhone: "",
      name: null
    },
    offerNumberMap: {
      applyingNumber: 0,
      processingNumber: 0,
      receivedNumber: 0,
      waitReceiveNumber: 0
    },
    msgNumber: 0,
    assetsInfoMap: {
      AvailBalance: "",
      accountBalance: "",
      gameAccountList: [],
      mainBalance: ""
    },
    serverInfo: {
      payDomain: "",
      withdrawMethod: ""
    },
    userCountInfo: {
      totalWithdraw: "",
      totalBonus: ""
    },
    vipInfo: {
      vipName: ""
    },
    rateInfo: {
      totalCapital: 0,
      totalRate: 0
    }
  },
  /**
   * 多彩宝*/
  colorNavIndex: 0,
  // 多彩宝游戏
  colorGameTypes: [
    { name: "所有游戏", code: -1 },
    // {name: '老虎机',code: 1},
    { name: "真人", code: 2 },
    { name: "体育", code: 3 },
    { name: "彩票", code: 4 },
    // {name: '捕鱼王',code: 5},
    { name: "棋牌", code: 6 },
    { name: "其他", code: 8 }
  ],
  colorStartMoney: 668229213.16,
  // 多彩宝客服
  COLOR_SERVICE:
    "https://chat.livechatvalue.com/chat/chatClient/chatbox.jsp?companyID=1089815&configID=85665&jid=6176249612&s=1",

  /**
   * 金色 */
  goldNavIndex: 0, // 一级导航
  articleTypeList: [],
  isRegisterPage: false,

  /**
   * 金沙*/
  // 是否在首页，首页弹窗
  jin_sha_global_login_state: false,
  // 是否登陆框是否需要聚焦
  is_login_focus: false,

  /**
   * 体育 */
  //客服
  SPORTS_SERVICE: "https://e-140112.chatnow.meiqia.com/dist/standalone.html",
  // 判断顶部导航颜色
  isAtSportsPage: true,
  scrollRange: 0, //存款需要的滚动距离
  sports_gameTypes: [
    { name: "所有游戏", code: -1 },
    { name: "电子游戏", code: 1 },
    { name: "真人视讯", code: 2 },
    { name: "体育投注", code: 3 },
    { name: "彩票游戏", code: 4 },
    { name: "捕鱼王", code: 5 },
    { name: "棋牌游戏", code: 6 },
    { name: "其他", code: 8 }
  ],
  // 体育种类导航
  // 1:足球  2:篮球  3：网球  8：棒球  15：飞镖  23：手球  25：冰上曲棍球  29：赛车  31：橄榄球  34：斯诺克/台球  40：排球
  sports_nav_index: 1,
  sports_navList: [
    { fullName: "主页", enName: "index", type: "index", sportsId: "" },
    { fullName: "足球", enName: "football", type: "game", sportsId: 1 },
    { fullName: "篮球", enName: "basketball", type: "game", sportsId: 2 },
    { fullName: "网球", enName: "tennis", type: "game", sportsId: 3 },
    { fullName: "棒球", enName: "baseball", type: "game", sportsId: 8 },
    { fullName: "飞镖", enName: "darts", type: "game", sportsId: 15 },
    { fullName: "手球", enName: "handball", type: "game", sportsId: 23 },
    { fullName: "冰上曲棍球", enName: "hockey", type: "game", sportsId: 25 },
    { fullName: "赛车", enName: "cycle-racing", type: "game", sportsId: 29 },
    { fullName: "橄榄球", enName: "rugby", type: "game", sportsId: 31 },
    {
      fullName: "斯洛克/台球",
      enName: "billiards",
      type: "game",
      sportsId: 34
    },
    { fullName: "排球", enName: "volley-ball", type: "game", sportsId: 40 }
  ],
  // 注册成功弹窗
  is_register_success: false,
  // 签到弹窗
  signin_activity_window: false,
  //邀请好友
  invite_users_window: false,
  // 是否已升级为代理
  is_agent_level: false
};
export default state



// WEBPACK FOOTER //
// ./src/common/store/state.js